import type { Column } from '@atlassian/jira-business-board-workflow-issues';
import { setBoardColumnOrder } from './services';

export const setColumnsOld = async (
	projectId: string,
	selectedWorkflow: string,
	updatedColumns: Column[],
) => {
	const request = {
		columnRequest: {
			workflowName: selectedWorkflow,
			columns: updatedColumns.map((c) => ({
				name: c.name,
				statusCategory: c.statusCategory,
				statusId: c.statusId,
				canCreateIssues: c.canCreateIssues,
				hasFilteredIssues: c.hasFilteredIssues,
			})),
		},
		projectId,
	};
	await setBoardColumnOrder(request);
};
export const persistStatusGroups = async (
	projectId: string,
	selectedWorkflow: string,
	updatedGroupIds: string[],
) => {
	const request = {
		columnRequest: {
			workflowName: selectedWorkflow,
			columns: updatedGroupIds.map((statusId) => ({ statusId })),
		},
		projectId,
	};
	await setBoardColumnOrder(request);
};
